/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Parents_TitleInputs */

const fr_guardian_parents_title = /** @type {(inputs: Guardian_Parents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parents`)
};

/**

* @param {Guardian_Parents_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_parents_title = /** @type {((inputs?: Guardian_Parents_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Parents_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_parents_title(inputs)
});